module.exports = __webpack_public_path__ + "static/media/capital_trabajo5.10e23080.jpg";